// ---------------------------------------------------------------
// EXPORT
// ---------------------------------------------------------------
export function log(value, state = false) {

    if(state === true) {
        console.log(value);
    }
}

export function errorlog(value, state = false) {

    if(state === true) {
        console.error(value);
    }
}
